// agenda.js
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const isEditor =
  document.body.classList.contains("block-editor-page") ||
  document.body.classList.contains("wp-admin");

if (!isEditor) gsap.registerPlugin(ScrollTrigger);

function imagesReady(scope, cb) {
  const imgs = Array.from(scope.querySelectorAll("img"));
  if (!imgs.length) return cb();
  let left = imgs.length;
  const done = () => (--left === 0 ? cb() : null);
  imgs.forEach((img) => {
    if (img.complete) return done();
    img.addEventListener("load", done, { once: true });
    img.addEventListener("error", done, { once: true });
  });
}

function initAgendaDay(day) {
  if (!day || day.__agendaDayInit) return;
  day.__agendaDayInit = true;

  const inner = day.querySelector(".agenda-day__inner");
  const media = day.querySelector(".agenda-day__media--top");
  const cards = gsap.utils.toArray(
    day.querySelectorAll('[data-animate="card"]')
  );

  gsap.set(inner, { opacity: 0, y: 36 });
  if (media) gsap.set(media, { opacity: 0, y: 24 });
  gsap.set(cards, { opacity: 0, y: 28 });

  const play = () => {
    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    tl.to(inner, { opacity: 1, y: 0, duration: 0.65 });

    if (media) tl.to(media, { opacity: 1, y: 0, duration: 0.45 }, "-=0.4");

    if (cards.length) {
      tl.to(
        cards,
        {
          opacity: 1,
          y: 0,
          duration: 0.55,
          stagger: 0.12,
        },
        "-=0.3"
      );
    }
  };

  if (isEditor) return play();

  ScrollTrigger.create({
    trigger: day,
    start: "top 80%",
    once: true,
    onEnter: play,
  });
}

function initAgenda(section) {
  if (!section || section.__agendaInit) return;
  section.__agendaInit = true;

  imagesReady(section, () => {
    section.querySelectorAll(".agenda-day").forEach(initAgendaDay);
  });
}

function mount() {
  document.querySelectorAll(".agenda").forEach(initAgenda);

  if (isEditor) {
    const root = document.querySelector(".editor-styles-wrapper") || document;
    new MutationObserver(() =>
      root.querySelectorAll(".agenda").forEach(initAgenda)
    ).observe(root, { childList: true, subtree: true });
  }
}

if (window.wp?.domReady) window.wp.domReady(mount);
else document.addEventListener("DOMContentLoaded", mount);
